export enum CurrencyEnum {
  EUR = '€'
}
